import styled from "styled-components";

import { colors, globalStyle } from "global/globalStyle";

export const Container = styled.div<any>`
  margin-left: ${({ marginLeft }) =>
    marginLeft && marginLeft.includes("px") ? marginLeft : `${marginLeft}px`};
  margin-right: ${({ marginRight }) =>
    marginRight && marginRight.includes("px")
      ? marginRight
      : `${marginRight}px`};
  margin-top: ${({ marginTop }) =>
    marginTop && marginTop.includes("px") ? marginTop : `${marginTop}px`};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom && marginBottom.includes("px")
      ? marginBottom
      : `${marginBottom}px`};

  text-align: start;

  .MuiInputBase-root {
    height: ${(props) => props.height ?? "48px"};
  }

  .input_outline fieldset {
    border-color: ${globalStyle.input.default};
    font-family: ${globalStyle.fontFamily};
    border-width: 2px;
  }

  .input_outline:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${globalStyle.input.hover};
  }

  .input_outline.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${globalStyle.input.focus};
  }

  svg {
    height: 22px;
    width: 22px;
    color: ${colors.general_icons};
  }

  button {
    padding-left: 17px;
    padding-right: 17px;
    cursor: default;

    &:hover {
      background-color: none;
      background: none;
    }
  }

  .MuiInputBase-input
    .MuiOutlinedInput-input
    .MuiInputBase-inputAdornedEnd
    .css-1uvydh2 {
    padding: 14px 14px;
  }
`;
